import { createLoggerFunc } from '@updater/ui-utilities';

export function createLogger() {
  return createLoggerFunc(true, '[DEBUG][TRACKER]', 'color: #fa6dea')();
}

export const logger = createLogger();
